import { inject, Injectable } from '@angular/core';
import {
  type EventCardLogsQueryQuery,
  type EventCardLogsQueryQueryVariables,
  type GoalCardLogsQueryQuery,
  type GoalCardLogsQueryQueryVariables,
  type LogItemFragmentFragment,
} from '@reconcept-platform/shared/types';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WorkspaceGraphQLService } from '../../workspace-graphql.service';
import { EventCardLogsQuery, GoalCardLogsQuery } from './log.queries';

@Injectable({
  providedIn: 'root',
})
export class LogApi {
  private workspaceGraphQLService = inject(WorkspaceGraphQLService);

  watchGoalCardLogs(goalCardIds: string[]): Observable<LogItemFragmentFragment[]> {
    return (
      this.workspaceGraphQLService
        .watchQuery<GoalCardLogsQueryQuery, GoalCardLogsQueryQueryVariables>({
          query: GoalCardLogsQuery,
          variables: {
            goalCardIds,
          },
        })
        // @ts-expect-error TS18049 possibly null or undefined
        .pipe(map((result) => result.data.cardLogs.nodes))
    );
  }

  watchEventCardLogs(eventCardIds: string[]): Observable<LogItemFragmentFragment[]> {
    return (
      this.workspaceGraphQLService
        .watchQuery<EventCardLogsQueryQuery, EventCardLogsQueryQueryVariables>({
          query: EventCardLogsQuery,
          variables: {
            eventCardIds,
          },
        })
        // @ts-expect-error TS18049 possibly null or undefined
        .pipe(map((result) => result.data.cardLogs.nodes))
    );
  }
}
